import React, { useEffect, useState } from 'react';
//import PropTypes from 'prop-types';
import { Box, Tab, Tabs } from '@mui/material';
import TabPanel from '../../components/common/TabPanel';
import { useLocation, useNavigate } from 'react-router';

function AiTrainingDataContent(props) {
    const { children } = props;

    const [activeTab, setActiveTab] = useState('library');
    const navigate = useNavigate();
    const location = useLocation();

    const aiTrainingDataTabs = [
        {
            value: 'orderSumSettings',
            label: 'Order Summarization Settings',
        },
        {
            value: 'library',
            label: 'Training Data',
        },
        {
            value: 'simulationResults',
            label: 'Simulation Results',
        },
    ];

    const handleChange = (event, tab) => {
        navigate(tab);
    };

    const resetState = () => {
        //debugger;
        const aiTrainingDataMenuTab =
            aiTrainingDataTabs.find((option) =>
                //location.pathname.endsWith(option.value)
                location.pathname.includes(option.value)
            ) ||
            // picks first item as default tab
            aiTrainingDataTabs[0];

        const tab = aiTrainingDataMenuTab?.value;
        //console.log('Activetab: ', tab);
        setActiveTab(tab);
    };

    useEffect(() => {
        resetState();
    }, [location.pathname]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="AiTrainingData Menu Tabs"
                    scrollButtons="auto"
                    variant="scrollable"
                >
                    {aiTrainingDataTabs.map(({ label, value }) => (
                        <Tab
                            key={value}
                            label={label}
                            value={value}
                            id={`aitrndata-menu-tab-${value}`}
                            aria-controls={`aitrndata-menu-tabpanel-${value}`}
                        />
                    ))}
                </Tabs>
            </Box>
            <TabPanel
                id={`aitrndata-menu-tabpanel-${activeTab}`}
                aria-labelledby={`aitrndata-menu-tabpanel-${activeTab}`}
                style={{ width: '100%' }}
            >
                {children}
            </TabPanel>
        </Box>
    );
}

AiTrainingDataContent.propTypes = {
    //children: PropTypes.shape({}),
};

export default AiTrainingDataContent;
